import React from 'react';
import { IconType } from 'react-icons';
import {
  FaEnvelopeSquare,
  FaPhoneSquareAlt,
  FaLinkedin,
  FaGithubSquare,
} from 'react-icons/fa';
import './ContactElement.css';

type PropsType = {
  slug: string;
  data?: string;
};

type IconConfig = {
  Icon: IconType;
  color?: string;
};

const icons: Record<string, IconConfig> = {
  email: {
    Icon: FaEnvelopeSquare,
    color: '#800020',
  },
  phone1: {
    Icon: FaPhoneSquareAlt,
    color: 'green',
  },
  phone2: {
    Icon: FaPhoneSquareAlt,
    color: '#c84100',
  },
  linkedin: {
    Icon: FaLinkedin,
    color: '#1857a2',
  },
  github: {
    Icon: FaGithubSquare,
  },
};

const toTelHref = (display: string): string => {
  const digits = display.replace(/[^\d+]/g, '');
  return `tel:${digits}`;
};

const getAnchorData = (contact: PropsType) => {
  switch (contact.slug) {
    case 'email':
      return { href: `mailto:${contact.data}`, target: '_blank' as const };
    case 'phone1':
    case 'phone2':
      return { href: toTelHref(contact.data || ''), target: undefined };
    default:
      return { href: contact.data, target: '_blank' as const };
  }
};

const ContactElement = (contact: PropsType) => {
  const { Icon, color } = icons[contact.slug];
  const { href, target } = getAnchorData(contact);

  return (
    <a
      key={ contact.slug }
      className='ContactElement'
      style={ { color: color || 'black' } }
      href={ href }
      target={ target }
      rel='noopener noreferrer'
    >
      <Icon size='1.5em' />
      &nbsp;
      { contact.data }
    </a>
  );
};

export default ContactElement;
